export default {
  messageType: 'Premium Video',
  title: 'Premium Video Settings',
  label: {
    videoUrl: 'Video URL',
    thumbnail: 'Video Thumbnail Image',
    title: 'Title',
    content: 'Content',
    preview: 'Preview Video',
  },
  button: {
    checkVideo: 'Watch Video',
  },
  placeholder: {
    link: 'URL with https://',
  },
  comment: {
    videoUrl: 'Please insert the video link registered on Kakao TV.',
    thumbnail: 'Recommended: 800×800 (1:1), 800×400 (2:1), 600×800 (3:4) / Max 500KB',
  },
};
